
import React, { useEffect } from 'react';
import './HomePageTwo.scss';

export default function HomePageTwo(props) {
  const { moveStatus, pageTabActive, leaveAnimation, isSmallScreen } = props;

  useEffect(() => {
    // if(pageTabActive === 1 && action === 'up') {
    // 	setTimeout(() => {
    // 		setState({
    // 			hasBg: true
    // 		})
    // 	}, 1000)
    // }else if(pageTabActive === 0 && action === 'down') {
    // 	setTimeout(() => {
    // 		setState({
    // 			hasBg: true
    // 		})
    // 	}, 1000)
    // } else if(pageTabActive === 2 && action === 'down') {
    // 	setTimeout(() => {
    // 		setState({
    // 			hasBg: true
    // 		})
    // 	}, 1000)
    // } else {
    // 	setState({
    // 		hasBg: false
    // 	})
    // }

  }, [pageTabActive]);
  // ${pageTabActive === 2  && 'translate'} ${step === 1 && 'show'} ${state.operate === 'down' && 'hidden'}

  return <div
    className={`home-content-two ${isSmallScreen && 'home-content-two-m'}`}
    id="temp2"
    style={{
      background: `${isSmallScreen || ((pageTabActive === 1) && !moveStatus) ? 'url(https://oss.5rs.me/oss/uploadfe/png/0ce32552a7263b209c02aeac19de8aad.png) no-repeat center center/19.2rem' : ''}`
    }}
  >
    <div className="home-content-two-container">
      <div className={`big ${(isSmallScreen || ((pageTabActive === 1) && !moveStatus)) && 'show'} ${!isSmallScreen && (pageTabActive === 0) && !moveStatus && 'hidden'} ${!isSmallScreen && pageTabActive > 1 && leaveAnimation && 'translate'}`}>
        <div className="big-rotate" />
        <div className="big-text">
          <div className="big-text-logo mt10">
            <img src="https://oss.5rs.me/oss/uploadfe/png/60eaa140dfaf610cba0aef60e1c3fe48.png" />
          </div>
          <div className="big-text-text mt10">
            <div className="big-text-title">-从出版而来 为出版奋进-</div>
            <div className="text-bg-wrapper">
              <p>数传集团成立于2014年，是一家专注出版行业的智能</p>
              <p>化转型服务商。公司当前在武汉、上海、北京、香</p>
              <p>港设有分公司，在全国15个省、直辖市</p>
              <p>设有本地化服务团队。</p>

            </div>
          </div>
        </div>
        <div className="small">
          <div className="rotate" />
          <div className="about">
            <img src="https://oss.5rs.me/oss/uploadfe/png/ef9efb77f570e7b8678684e9f3af775a.png" />
          </div>
        </div>
      </div>
    </div>
  </div>;
}